<style>
</style>
<template>
  <v-container fluid id="payment--view">
    <router-view></router-view>
    <v-row class="secondary">
      <v-container fluid style="max-width: 960px;">
        <v-row>
          <v-col cols="12">
            <div class="headline primary--text">{{ $t('Doručení objednávky a platba') }}</div>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-container fluid class="px-0 py-0 mt-8" style="max-width: 960px;">
      <payment-order></payment-order>
    </v-container>
    <v-row class="background: grey lighten-1">
      <v-container fluid class="px-0 py-0" style="max-width: 960px;">
        <v-alert type="info" color="grey lighten-1">
          {{ $t('Zde dokončíte svůj nákup. S dokončením nákupu vyjadřujete svůj souhlas s ') }}<a
            :href="institutionTaC" target="_blank">{{ $t('obchodními podmínkami') }}</a>{{ ' a se zpracováním osobních údajů.' }}
        </v-alert>
      </v-container>
    </v-row>
  </v-container>
</template>
<script>
    import BasketMixin from '@/mixins/basket-mixin'
    import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin'
    import StorageMixin from '@/mixins/storage-mixin'
    import PaymentOrder from '@/components/payment-order.vue'

    export default {
        name: 'PaymentPage',
        mixins: [BasketMixin, InstitutionMixin, StorageMixin],
        components: {
            'payment-order': PaymentOrder
        }
    }
</script>
